// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.miniworkflow.MiniWorkflowQueueWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { SubmitMiniWorkflowDataWebApiRequestDto, SubmitMiniWorkflowDataWebApiResponseDto } from '../..';

export const MiniWorkflowQueueWebApiHandler_submitMiniWorkflowData_Path =
  '/api/web/v1/miniworkflow/submitMiniWorkflowData';

/**
 * add data when in the context of a mini workflow
 */
export const MiniWorkflowQueueWebApiHandler_submitMiniWorkflowData = (
  postData: SubmitMiniWorkflowDataWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SubmitMiniWorkflowDataWebApiRequestDto, SubmitMiniWorkflowDataWebApiResponseDto>(
    {
      endpoint: MiniWorkflowQueueWebApiHandler_submitMiniWorkflowData_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};
